import React, { FC } from 'react';

import { LottieAnimation } from 'components/animation';

import initialAnimation from './json/initial.json';
import loadingAnimation from './json/loading.json';
import transitionAnimation from './json/transition.json';

export const LoadingAnimation: FC = () => (
  <LottieAnimation
    ariaRole="presentation"
    data-testid="reset-location-loading-animation"
    options={{ animationData: loadingAnimation }}
  />
);

export const TransitionAnimation: FC<{ onComplete: VoidFunction }> = ({ onComplete }) => (
  <LottieAnimation
    ariaRole="presentation"
    data-testid="reset-location-transition-animation"
    options={{ animationData: transitionAnimation }}
    onComplete={onComplete}
  />
);

export const InitialAnimation: FC = () => (
  <LottieAnimation
    ariaRole="presentation"
    data-testid="reset-location-initial-animation"
    options={{ animationData: initialAnimation, loop: false }}
  />
);
